import { Provider } from '@repo/api-gw-sdk';

import { useSourceAccounts } from './useSourceAccounts';

export const useCloudProviders = () => {
  const { sourceAccounts } = useSourceAccounts();
  const providers = Array.from(
    new Set((sourceAccounts || []).map((x) => x.cloudProvider))
  );
  return providers;
};

export const getAllCloudProviders = (isDemoOrDev: boolean) =>
  Object.values(Provider).filter(
    (x) =>
      x !== Provider.ProviderUnspecified &&
      (isDemoOrDev || x !== Provider.MongoAtlas)
  );
